const search = {
  get (text) {
    return `/homeowner/cases/search?searchTerm=${text}`;
  },
  getNew (text) {
    return `/homeowner/cases/search/new?searchTerm=${text}`;
  }
};

export default search;
